import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'
import { getBlockingTypes } from '../tanimlamalar/blokaj-tipleri/api'

// The types a user can write into the optional "Blokaj Tipi" column, and what each one blocks
// (maintained in Tanımlamalar > Blokaj Tipleri).
const BlockingTypeInfo = () => {
    const [types, setTypes] = useState([]);
    useEffect(() => { getBlockingTypes().then((r) => setTypes(r.filter((x) => x.is_active))).catch(() => {}); }, []);
    const yn = (b) => (b ? 'Engeller' : '—');
    return (
        <Row className="mt-2">
            <Col md="12">
                <span style={{ color: "blue", fontWeight: "bold" }}>Blokaj Tipi kolonu (isteğe bağlı):</span>
                <ul className="mb-2 mt-1">
                    <li>Kod (ör. KALITE) veya ad yazılabilir. Kolon dosyada hiç olmayabilir; eski şablonlar aynen çalışır.</li>
                    <li><b>EKLE</b>: Aciklamas zorunludur. Tip boşsa blokaj <b>Diğer</b> olarak kaydedilir ve uyarı verilir.</li>
                    <li><b>KALDIR</b>: tip yazılırsa yalnızca o tipteki blokaj kalkar; boşsa aracın tüm blokajları kalkar.</li>
                    <li>Bir araçta birden fazla tip aynı anda aktif olabilir. Sistem tipleri yüklemeyle eklenemez.</li>
                </ul>
                <table className="table table-bordered table-sm">
                    <thead><tr style={{ backgroundColor: "#e2e2e2" }}>
                        <th>Kod</th><th>Ad</th><th>Grupaj</th><th>Kapı çıkışı</th><th>Transfer</th><th>Kaldıran</th><th></th>
                    </tr></thead>
                    <tbody>{types.map((x) => (
                        <tr key={x.code} style={x.is_system ? { color: "#888" } : {}}>
                            <td><b>{x.code}</b></td><td>{x.name_tr}</td><td>{yn(x.blocks_groupage)}</td><td>{yn(x.blocks_gate_exit)}</td>
                            <td>{yn(x.blocks_transfer)}</td><td>{x.released_by}</td><td>{x.is_system ? 'Sistem (yüklenemez)' : ''}</td>
                        </tr>
                    ))}</tbody>
                </table>
            </Col>
        </Row>
    );
};

const BlokajEkle = () => {
    return (
        <>
            <ExcelUpload
                role_name="genel_blokaj_write"
                requiredColumnsSase={[
                    "sase", "action", "Telep Eden Bayi", "Aciklamas"
                ]}
                optionalColumns={["Blokaj Tipi"]}
                exampleData={[{
                    sase: "VR1JCYHZUPY572549",
                    action: "EKLE",
                    "Telep Eden Bayi": "UK",
                    Aciklamas: "Klima arızası, yard hold",
                    "Blokaj Tipi": "KALITE"
                },
                {
                    sase: "VR1JCYHZUPY572549",
                    action: "KALDIR",
                    "Telep Eden Bayi": "UK",
                    Aciklamas: "Klima onarıldı",
                    "Blokaj Tipi": "KALITE"
                }]}
                extraInfo={<BlockingTypeInfo />}
                process_type="BLOCKING"
                ExcelName={"Hatalı Blokaj Verileri"}
                Title={"Blokaj Ekle"}
            />
        </>
    )
}

export default BlokajEkle
